import React from 'react';
import { Typography } from '@mui/material';

interface DialogHeadingProps {
  title: string;
  /** Context line: who or what the dialog is about. Truncated rather than wrapped. */
  subtitle?: string;
}

/**
 * Title block for `DialogTitle`. Keeps the two-line header identical across dialogs instead of
 * each one picking its own font size for the same role.
 */
const DialogHeading: React.FC<DialogHeadingProps> = ({ title, subtitle }) => (
  <>
    <Typography component="span" sx={{ display: 'block', fontSize: '1rem', fontWeight: 600 }}>
      {title}
    </Typography>
    {subtitle ? (
      <Typography
        component="span"
        noWrap
        sx={{ mt: 0.5, display: 'block', fontSize: '0.875rem', color: 'text.secondary' }}
      >
        {subtitle}
      </Typography>
    ) : null}
  </>
);

export default DialogHeading;
